import { setCookie } from 'ha/modules/Cookies';

const trackGclid = gclid => dispatch => {
  if (gclid) dispatch(setCookie('gclid', gclid, { expires: 90 }));
};

export default trackGclid;
